<template>
  <div class="d-flex flex-wrap ga-1">
    <v-chip v-if="address.isPrimaryAddress" size="small">
      {{ $t('address.primaryAddress') }}
    </v-chip>
    <v-chip v-if="address.isDefaultBillingAddress && !isQuotesPortal" size="small">
      {{ $t('billingAddress') }}
    </v-chip>
    <v-chip v-if="address.isDefaultDeliveryAddress && !isQuotesPortal" size="small">
      {{ $t('order.shippingAddress') }}
    </v-chip>
  </div>
</template>

<script setup lang="ts">
import { isQuotesPortal } from '@/helpers'
import { ShopAddress } from '@/types/index'
import { PropType } from 'vue'

defineProps({
  address: {
    type: Object as PropType<ShopAddress>,
    required: true
  }
})
</script>
